<span 
    class="badge" 
    [class.badge-danger]="reference.inventory < 0"
    [class.badge-light]="reference.inventory == 0"
    [class.badge-primary]="reference.inventory == 1"
    [class.badge-success]="reference.inventory > 1">
  {{ reference.inventory }}
</span>